import { render, staticRenderFns } from "./OnboardingWelcome.vue?vue&type=template&id=460d6e12&scoped=true&"
import script from "./OnboardingWelcome.vue?vue&type=script&lang=js&"
export * from "./OnboardingWelcome.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingWelcome.vue?vue&type=style&index=0&id=460d6e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d6e12",
  null
  
)

export default component.exports